/**
 * ⭐⭐⭐ **Notifikasi keluar** — taksonomi jenis & kanal (Imron, 2026-08-23).
 *
 * ### ⛔ Kenapa taksonominya di `contract`, bukan di server
 * Tiga lapis menyebut nama-nama ini: server yang menerbitkan peristiwa, portal yang menyusun
 * langganan, dan (kelak) adapter tiap kanal. Kalau daftarnya hidup di satu lapis, dua lapis lain
 * mengejanya sebagai string — dan `'shift_variance'` vs `'shift-variance'` adalah bug yang tak
 * bergejala sampai ada yang tak menerima notifikasi yang ia yakin sudah dilanggani.
 */
/**
 * Jenis peristiwa yang bisa dilanggan.
 *
 * ⛔ Sengaja SEDIKIT. Tiap jenis di sini punya pemicu yang sudah berjalan di server hari ini;
 * jenis yang "akan ada pemicunya nanti" berarti pemilik melanggan sesuatu yang takkan pernah tiba,
 * lalu menyimpulkan mesin notifikasinya rusak.
 */
export const NOTIFICATION_KINDS = Object.freeze([
    /** Sesi kas ditutup dengan selisih ≠ 0 — kontrol paling ketat yang dulu berhenti di layar kasir. */
    'shift_variance',
    /** Hari usaha ditutup — ringkasan omzet & selisih hari itu. */
    'day_closed',
    /** Dokumen penjualan tablet DITOLAK server (`SYNC-409-VARIANCE`) — uang sudah diterima tamu. */
    'sale_rejected',
]);
const KIND_SET = new Set(NOTIFICATION_KINDS);
export function isNotificationKind(v) {
    return KIND_SET.has(v);
}
/**
 * Kanal pengiriman.
 *
 * ⛔ v1 = `telegram` saja — bukan kekurangan yang harus diminta maaf, melainkan satu-satunya kanal
 * yang bisa dikirim HARI INI tanpa kredensial yang belum dimiliki siapa pun (SMTP) atau penyedia
 * berbayar (WA). Menaruh `email`/`whatsapp` di sini sekarang berarti layar menawarkannya, tujuan
 * tersimpan, dan pesannya menguap tanpa suara.
 *
 * ⭐ "In app" bukan kanal: ia pembacaan `notification_event` langsung. Kanal in-app akan melahirkan
 *   status "gagal mengantar ke layar yang sedang tak dibuka", keadaan yang tak punya arti.
 */
export const NOTIFICATION_CHANNELS = Object.freeze(['telegram']);
const CHANNEL_SET = new Set(NOTIFICATION_CHANNELS);
export function isNotificationChannel(v) {
    return CHANNEL_SET.has(v);
}
export const NOTIFICATION_STATUSES = Object.freeze(['pending', 'sent', 'failed']);
/**
 * ⭐ Berapa kali sebuah pengiriman dicoba sebelum menyerah.
 *
 * ⚠️ Menyerah itu SAH dan harus terlihat: antrean yang mencoba selamanya menyembunyikan token bot
 * yang salah di balik "sedang dicoba" selama berminggu-minggu.
 */
export const NOTIFICATION_MAX_ATTEMPTS = 5;
/** Jeda mundur eksponensial (detik) per percobaan ke-N (1-indexed), dipotong di elemen terakhir. */
export function notificationBackoffSeconds(attempt) {
    const tangga = [30, 120, 600, 1800];
    return tangga[Math.min(Math.max(attempt, 1), tangga.length) - 1] ?? 1800;
}
//# sourceMappingURL=notify.js.map